import React, { PropTypes } from 'react';
import './styles.scss';

export const Container = props => (
  <div className='container'>
    {props.children}
  </div>
);

Container.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]),
};

export default Container;



// WEBPACK FOOTER //
// ./src/components/shared/container/main.jsx